export { default as StatsBox } from './component';
